export default class ErrorBag {
    constructor() {
        this.errors = {};
    }

    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    get(field, index = 0) {
        if (this.errors[field]) {
            return this.errors[field][index]
        }
    }

    any() {
        return Object.keys(this.errors).length > 0;
    }

    record(errors) {
        this.errors = errors;
    }

    keys() {
        return Object.keys(this.errors);
    }

    clear(field) {
        delete this.errors[field];
    }

    clearAll() {
        this.errors = {};
    }
}
